export { default } from "./knowledgeBase"
